class InitialsComponent extends HTMLElement {
  constructor(){
    super();
    this.productInfoContainer = this.closest('.product__info-container');
    this.variantRadios = this.productInfoContainer.querySelector('variant-radios');
    this.lettersEl = this.productInfoContainer.querySelector('.letters-fieldset');
    this.input = this.querySelector('input');
    this.dynamicInitials = this.querySelector('.dynamic-initials');
    this.timerTimeout = 0;
    this.typingTimer;
    this.additionalInputs = this.querySelectorAll('input[extra-initials]');
    this.extensionsScript = this.querySelector('script[type="application/json"]');
    this.extensions = this.extensionsScript ? JSON.parse(this.extensionsScript.textContent) : [];
    this.isExtended = this.dataset.initialsExtended == 'true';

    this.affirm = document.querySelector('.affirm-as-low-as');
    this.currentAffirmAmount;

    this.variantChangeUnsubscriber = undefined;
  }

  updateInitialsLength(event){
    if (event.inputType == 'insertText' && event.data == ' '){
      this.input.value = this.input.value.replace(/\s/g, '');
      return;
    }
    
    if(!this.isExtended) {
      this.dynamicInitials ? this.dynamicInitials.textContent = this.input.value.length : '';
      this.resetTypingTimer();
    } else {
      this.updateTotalLetterCount();
    }
  }

  resetTypingTimer() {
    let input = this.input;
    let parentEl = this.lettersEl;
    let variantRadios = this.variantRadios;

    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {this.afterTypingStopped(parentEl, input, variantRadios)}, this.timerTimeout);
  }

  afterTypingStopped(parentEl, input, variantRadios) {
    if (!parentEl || !input || !variantRadios) return;

    let selectedLetters = input.value.length;
    let minLength = input.minLength;
    let allLetters = parentEl.querySelectorAll('input');
    let letterCheckbox = parentEl.querySelector(`input[value="${selectedLetters > minLength ? selectedLetters : minLength}"]`);
    let letterCheckboxLetters = parentEl.querySelector(`input[value="${selectedLetters > minLength ? selectedLetters == 1 ? selectedLetters + " Letter" : selectedLetters + " Letters" : minLength == 1 ? minLength + " Letter" : minLength + " Letters"}"]`);
    let letterCheckboxLettersLowercase = parentEl.querySelector(`input[value="${selectedLetters > minLength ? selectedLetters == 1 ? selectedLetters + " letter" : selectedLetters + " letters" : minLength == 1 ? minLength + " letter" : minLength + " letters"}"]`);

    allLetters.forEach(item => {
      item.removeAttribute('checked');
      item.checked = false;
      if(item == letterCheckbox || item == letterCheckboxLetters || item == letterCheckboxLettersLowercase){
        item.setAttribute('checked', '');
        item.checked = true;
        variantRadios.onVariantChange();
      }
    })
  }

  updateTotalLetterCount() {
    const additionalLetters = Array.from(this.additionalInputs).reduce((acc, item) => {
      const inc = item.value.length > 0 ? item.value.length : 0;
      return acc + inc;
    }, 0);

    this.totalLetterCount = this.input.value.length + additionalLetters;
    this.dynamicInitials ? this.dynamicInitials.textContent = this.totalLetterCount : '';
    this.updateProductInformation();
  }

  getExtensionForCombination() {
    if(!this.extensions || !this.extensions.length) return;

    const currentVariantCombination = `${this.currentVariantCombination}|${this.totalLetterCount}`;
    const extensionForCombination = this.extensions.find(extension => {
      const formattedOptions = extension.options.replace(/\\/g, '');
      return formattedOptions == currentVariantCombination;
    });

    return extensionForCombination;
  }

  updateProductInformation() {
    const extensionForCombination = this.getExtensionForCombination();

    if(!extensionForCombination) return;

    this.closest('product-info').querySelector('.price-item--regular').textContent = extensionForCombination.price;
    this.closest('product-info').querySelector('form[action="/cart/add"] .price-item--regular').textContent = extensionForCombination.price;

    document.querySelector('form[action="/cart/add"] input[name="id"]').value = extensionForCombination.id;

    if(this.affirm && extensionForCombination.price_unformatted) {
      this.affirm.setAttribute('data-amount', extensionForCombination.price_unformatted);
      this.currentAffirmAmount = extensionForCombination.price_unformatted;
      window.affirm.ui.refresh();
    }
  }

  handleExtraInitialsInput(event) {
    if (event.inputType == 'insertText' && event.data == ' '){
      event.target.value = event.target.value.replace(/\s/g, '');
      return;
    }
    this.updateTotalLetterCount();
  }

  updateCurrentVariantCombination(variantCombination) {
    if(variantCombination) {
      this.currentVariantCombination = variantCombination;
      this.updateProductInformation();
      return;
    }

    this.currentVariantCombination = Array.from(this.closest('product-info').querySelectorAll('variant-radios input:not([name="Letters"])[checked]')).map(item => item.value).join('|');
  }

  attachAffirmObserver() {
    const config = {
      attributes: true
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        observer.disconnect();
        const extensionForCombination = this.getExtensionForCombination();

        if(extensionForCombination) {
          this.affirm.setAttribute('data-amount', extensionForCombination.price_unformatted);
          this.currentAffirmAmount = extensionForCombination.price_unformatted;
          window.affirm.ui.refresh();
        }
        
        observer.observe(this.affirm, config);
      }
    })

    observer.observe(this.affirm, config);
  }

  connectedCallback(){
    if(this.isExtended) {
      if(this.affirm) {
        this.attachAffirmObserver();
      }
 
      this.updateCurrentVariantCombination();
      this.additionalInputs.forEach(item => {
        item.addEventListener('input', this.handleExtraInitialsInput.bind(this));
      })
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        const newCombination = e.data.variant.options.slice(0, 2).join('|');
        this.updateCurrentVariantCombination(newCombination);
      });
    }
    
    this.input.addEventListener('input', this.updateInitialsLength.bind(this));
  }

  disconnectedCallback(){
    this.input.removeEventListener('input', this.updateInitialsLength.bind(this));

    if(this.isExtended) {
      if(this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
      this.additionalInputs.forEach(item => {
        item.removeEventListener('input', this.handleExtraInitialsInput.bind(this));
      })
    }
  }
}

if(!window.customElements.get('initials-component')) {
  window.customElements.define('initials-component', InitialsComponent);
}
